import "core-js/modules/es.number.constructor";
import _classCallCheck from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createClass";
import _createSuper from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createSuper";
import _inherits from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/inherits";
import { __decorate } from "tslib";
import Vue from 'vue';
import { Component, Prop, Emit } from 'vue-property-decorator';

var AppDatePicker = /*#__PURE__*/function (_Vue) {
  _inherits(AppDatePicker, _Vue);

  var _super = _createSuper(AppDatePicker);

  function AppDatePicker() {
    var _this;

    _classCallCheck(this, AppDatePicker);

    _this = _super.apply(this, arguments);
    _this.model = '';
    _this.show = false;
    _this.rules = {
      required: function required(value) {
        return !!value || '不能为空!';
      }
    };
    _this.top = 0;
    _this.left = 0;
    return _this;
  }

  _createClass(AppDatePicker, [{
    key: "mounted",
    value: function mounted() {
      this.model = this.value;
    }
  }, {
    key: "clearModel",
    value: function clearModel() {
      this.valueChangedHandler('');
    }
  }, {
    key: "valueChangedHandler",
    value: function valueChangedHandler(val) {
      this.model = val;
      this.show = false;
      return val;
    }
  }, {
    key: "submit",
    value: function submit() {}
  }, {
    key: "handlefocus",
    value: function handlefocus() {
      var pickerIcon = this.$refs.pickerIcon;
      this.top = pickerIcon.getBoundingClientRect().y - 100;
      this.left = pickerIcon.getBoundingClientRect().x - 266;
      this.show = true;
    }
  }, {
    key: "allowedDates",
    value: function allowedDates(val) {
      var endDate = this.endDate ? this.endDate === 'max' ? this.$moment().add(100, 'y') : this.$moment(this.endDate) : this.$moment();
      var isBefore = this.$moment(val).isAfter(this.$moment(this.startDate));
      var isAfter = this.$moment(val).isBefore(endDate);
      return isBefore && isAfter;
    }
  }]);

  return AppDatePicker;
}(Vue);

__decorate([Prop(String)], AppDatePicker.prototype, "value", void 0);

__decorate([Prop(String)], AppDatePicker.prototype, "label", void 0);

__decorate([Prop({
  type: String
})], AppDatePicker.prototype, "placeholder", void 0);

__decorate([Prop({
  type: String,
  default: '1900-01-01'
})], AppDatePicker.prototype, "startDate", void 0);

__decorate([Prop({
  type: String
})], AppDatePicker.prototype, "endDate", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], AppDatePicker.prototype, "required", void 0);

__decorate([Prop({
  type: [Number, String],
  default: 289
})], AppDatePicker.prototype, "width", void 0);

__decorate([Prop({
  type: [Number, String],
  default: 36
})], AppDatePicker.prototype, "height", void 0);

__decorate([Emit('input')], AppDatePicker.prototype, "valueChangedHandler", null);

__decorate([Emit()], AppDatePicker.prototype, "submit", null);

AppDatePicker = __decorate([Component], AppDatePicker);
export default AppDatePicker;